(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'styled-components', 'react-emotion'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('styled-components'), require('react-emotion'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.styledComponents, global.reactEmotion);
    global.WhitespaceColumn = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _styledComponents, _reactEmotion) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _react2 = _interopRequireDefault(_react);

  var _styledComponents2 = _interopRequireDefault(_styledComponents);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n  background-color: ', ';\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  flexflow: column nowrap;\n'], ['\n  background-color: ', ';\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  flexflow: column nowrap;\n']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  flex-flow: column nowrap;\n'], ['\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  flex-flow: column nowrap;\n']);

  var RightCol = _styledComponents2.default.div(_templateObject, function (props) {
    return props.theme.primaryTone;
  });
  var RightColWrapper = _styledComponents2.default.div(_templateObject2);

  var getClasses = function getClasses(props) {
    if (props.third) return 'col-sm-12 col-md-4';
    if (props.full) return 'col-sm-12';
    return 'col-md-12 col-lg-6';
  };

  var Column = function Column(props) {
    return _react2.default.createElement(
      RightCol,
      { className: (0, _reactEmotion.cx)(getClasses(props), props.className) },
      _react2.default.createElement(
        RightColWrapper,
        null,
        props.children
      )
    );
  };

  exports.default = Column;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/layout/WhitespaceColumn.js
// module id = 765
// module chunks = 1